function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from "axios";
import lodash from "lodash";
export default {
  props: {
    categoryClass: String,
    yearClass: String,
    path: String,
    position: String,
    param: String,
    otherParam: {
      type: String,
      default: ""
    },
    limit: Number,
    count: Number
  },
  data: function data() {
    return {
      query: "",
      catdata: [],
      yeardata: [],
      endpoint: "/".concat(this.path, "/"),
      // url: "https://api.myjson.com/bins/1318u5"
      url: "//".concat(location.host, "/").concat(this.path, "/json/archive-list.json")
    };
  },
  mounted: function mounted() {
    this.query = this.setQuery();
    this.loadData();
  },
  methods: {
    setQuery: function setQuery() {
      if (window.location.search === "" || window.location.search === void 0 || window.location.search == null) {
        return {
          page: 1,
          category: "",
          year: ""
        };
      }

      var variables = window.location.search.split("?")[1].split("&"),
          obj = {};
      variables.forEach(function (v, i) {
        var variable = v.split("=");

        if (variable[0] == "category" || variable[0] == "year") {
          obj[variable[0]] = variable[0] + "=" + variable[1];
        }
      });
      if (!obj["category"]) obj.category = "";
      if (!obj["year"]) obj.year = "";
      return obj;
    },
    setPosition: function setPosition(pos) {
      if (pos == "bottom") {
        return "u-pt-40";
      }
    },
    setCategoryData: function setCategoryData(data) {
      if (data === "" || data === void 0 || data == null) return data;
      var result = [];

      _.map(data, function (entry) {
        _.forEach(entry.categories, function (value, key) {
          result.push(value);
        });
      });

      result = _.compact(result);
      result = _.uniqWith(result, _.isEqual);
      result = _.sortBy(result, ['id']);
      return result;
    },
    setYearData: function setYearData(data) {
      if (data === "" || data === void 0 || data == null) return data;

      var result = _.map(data, 'fiscalyear');

      result = _.uniq(result);
      result.sort(function (a, b) {
        return a < b ? 1 : -1;
      });
      return result;
    },
    loadData: function () {
      var _loadData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios.get(this.url).then(function (res) {
                  if (_this.categoryClass) _this.catdata = _this.setCategoryData(res.data);
                  if (_this.yearClass) _this.yeardata = _this.setYearData(res.data);
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                // alert("データの取得に失敗しました、リロードしてください。");
                alert(_context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function loadData() {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }()
  }
};